import React, {useEffect, useState} from "react";
import CustomCard from "../CustomCard";
import FormGenerator from "./FormGenerator";
import {Actions} from "../../../client/Actions";
import {Button} from "react-bootstrap";
import QrCodeButton from "../qrCode/QrCodeButton";

const CardFormDetails = ({
                             setLoader,
                             initialData,
                             shadow,
                             fields,
                             reload,
                             underCard,
                             qrCode,
                             api,
                             className,
                             readonly,
                             withoutHeader,
                             title,
                             withToggle,
                             onToggleChange,
                             hideIfNull,
                             width = 6
                         }) => {

        const [formData, setFormData] = useState(!!withToggle);
        const [hideBody, setHideBody] = useState(withToggle);


        const loadData = () => {
            if (initialData) {
                onDataLoaded(initialData);
            } else {
                setLoader(true);
                Actions.get(api, onDataLoaded);
            }


        };

        const onDataLoaded = (response) => {
            setFormData(response);
            setLoader(false);
        };


        useEffect(() => {
                if (onToggleChange) {
                    onToggleChange(!hideBody)
                }

            }, [hideBody]
        )

        function prepareTittle() {
            return <>
                <div className="float-left pt-2">
                    {title}
                </div>


                {withToggle ?
                    <div className="float-right ml-2">
                        <Button
                            variant={"outline-primary"}
                            onClick={() => setHideBody(!hideBody)}
                            className="accordion-button">


                            {!hideBody ?
                                <i className="fas fa-chevron-circle-up text-primary h5"></i> :
                                <i className="fas fa-chevron-circle-down text-primary h5"></i>
                            }
                        </Button>
                    </div>
                    : ""}
                {qrCode && (withToggle && !hideBody) ?
                    <div className="float-right">

                        <QrCodeButton
                            value={formData[qrCode]}
                            filePrefix={"qrCode"}
                        />

                    </div>
                    : ""
                }
            </>;
        }


        useEffect(loadData, [reload]);


        return (
            <>

                <CustomCard title={prepareTittle()}
                            shadow={shadow}
                            underCard={underCard}
                            className={className}
                            withoutHeader={withoutHeader}
                            hideBody={hideBody}
                            width={width}>
                    <FormGenerator fields={fields}
                                   formData={formData}
                                   initData={true}
                                   setFormData={setFormData}
                                   hideIfNull={hideIfNull}
                                   setReady={()=>{}}
                                   readOnly={readonly}/>

                </CustomCard>


            </>
        );
    }
;


export default CardFormDetails;